import { Component, OnInit } from "@angular/core";
import { ModalController, IonicModule } from "@ionic/angular";

@Component({
    selector: "app-iosa2hs",
    templateUrl: "./iosa2hs.component.html",
    styleUrls: ["./iosa2hs.component.scss"],
    standalone: true,
    imports: [IonicModule],
})
export class Iosa2hsComponent implements OnInit {
  constructor(private modalCtrl: ModalController) { }

  ngOnInit() { }

  close() {
    this.modalCtrl.dismiss().catch(err => {
      return err
    });
  }
}
